import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { Challenge, ChallengeService, Team, TeamMembershipStatus, TeamUser } from 'app/shared/services/challenge.service';
import { Subject } from 'rxjs';

/**
 * Component to display user list item in next challenge tab
 */
@Component({
  selector: 'app-next-challenge-user',
  templateUrl: './next-challenge-user.component.html',
  styleUrls: ['./next-challenge-user.component.scss'],
})
export class NextChallengeUserComponent implements OnDestroy, OnInit {
  // The next challenge
  @Input() challenge: Challenge;

  // Team of the user
  @Input() team: Team;

  // Index displayed for users, which are team members or invited (but not for applicants)
  @Input() index: number;

  // User that should be displayed
  @Input() user: TeamUser;

  // Team user object of the currently logged in user
  public loggedInUser: TeamUser;

  public confirmMode: boolean = false;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  // Reference to TeamMembershipStatus to be able to use it in template
  public TeamMembershipStatus: typeof TeamMembershipStatus = TeamMembershipStatus;

  constructor(private challengeService: ChallengeService, private translate: TranslateService, private snackBar: MatSnackBar) {}

  public ngOnInit() {
    this.challengeService.teamUser.takeUntil(this.ngUnsubscribe).subscribe((teamUser) => {
      this.loggedInUser = teamUser;
    });
  }
  /**
   * Switch to confirmation mode
   */
  public displayConfirmMode() {
    this.confirmMode = true;
  }

  /**
   * Cancel confirmation mode
   */
  public cancelConfirmMode() {
    this.confirmMode = false;
  }

  /**
   * Removes the given user from the team
   */
  public removeUser() {
    this.challengeService.removeUserFromTeam(this.challenge._id, this.team._id, this.user._id).catch(() => {
      this.challengeService.reloadTeams();
    });
  }

  /**
   * Accept application of a user to the team
   */
  public acceptApplication() {
    this.challengeService.acceptApplication(this.challenge._id, this.team._id, this.user._id).catch((error) => {
      const errorObject = error.body.error.error;

      if (errorObject.startsWith('maximum_challenge_members')){
        this.translate.get('CHALLENGE.error.maximumChallengeMemberReached').subscribe((text) => {
          this.snackBar.open(text, null, {
            verticalPosition: 'top',
            duration: 4000,
            panelClass: ['b2a-error', 'top'],
          });
        });
      }
      this.challengeService.reloadTeams();
    });
  }

  /**
   * Cancels application of a user to the team
   */
  public declineApplication() {
    this.challengeService.cancelApplication(this.challenge._id, this.team._id, this.user._id).catch(() => {
      this.challengeService.reloadTeams();
    });
  }

  /**
   * Cancels an invitation of the user to the team
   */
  public cancelInvitation() {
    this.challengeService.declineInvitation(this.challenge._id, this.team._id, this.user.email).catch(() => {
      this.challengeService.reloadTeams();
    });
  }

  /**
   * On destroy cancel active subscriptions
   */
  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/challenge-statistics/components/next-challenge-user/next-challenge-user.component.ts